import type { EntityType } from './entity-access.model';

export const ENTITY_ACCESS_CLEANUP_PORT = 'ENTITY_ACCESS_CLEANUP_PORT';

export interface EntityAccessCleanupPort {
  deleteAllForEntity(entityType: EntityType, entityId: string, tx: unknown): Promise<void>;
}
